export const sortByCreatedAt = (a: any, b: any, direction: "asc" | "desc" = "desc"): number =>
  direction === "desc"
    ? new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    : new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();

export const sortByVisibleFrom = (a: any, b: any): number =>
  new Date(b.visibleFrom).getTime() - new Date(a.visibleFrom).getTime() ||
  new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
